module.exports = __webpack_public_path__ + "assets/dfe57eb36b1d8d334e48eec6e8d1f611.png";